import { render } from "./header.component.vue?vue&type=template&id=6344243d&scoped=true&ts=true"
import script from "./header.component.ts?vue&type=script&lang=ts"
export * from "./header.component.ts?vue&type=script&lang=ts"

import "./header.component.vue?vue&type=style&index=0&id=6344243d&lang=less&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6344243d"]])

export default __exports__